import { render, staticRenderFns } from "./LiquorDetail.vue?vue&type=template&id=21c3d9a8&scoped=true&"
import script from "./LiquorDetail.vue?vue&type=script&lang=js&"
export * from "./LiquorDetail.vue?vue&type=script&lang=js&"
import style0 from "./LiquorDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LiquorDetail.vue?vue&type=style&index=1&id=21c3d9a8&lang=scss&scoped=true&"
import style2 from "./LiquorDetail.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c3d9a8",
  null
  
)

export default component.exports